import React from 'react';
import BarbarianTrackerHexInactive from '@static/images/barbarian_tracker_hex_inactive.svg';
import BarbarianTrackerHexActive from '@static/images/barbarian_tracker_hex_active.svg';
import BarbarianTrackerHexAttack from '@static/images/barbarian_tracker_hex_attack.svg';
export const BARBARIAN_INVASION_TRACKER_HEX_PROPS_TYPES = [
    'inactive',
    'active',
    'attack'
];
const HEX_TYPE_MAP = {
    inactive: BarbarianTrackerHexInactive,
    active: BarbarianTrackerHexActive,
    attack: BarbarianTrackerHexAttack
};
export const UIGameBarbarianInvasionTrackerHex = ({ type, className })=>/*#__PURE__*/ React.createElement("img", {
        className: className,
        src: HEX_TYPE_MAP[type]
    });
